import { apiService } from "../../../../../../../../services/apiService";
import { apiServiceConstants } from "../../../../../../../../constants";
import { utilService } from "../../../../../../../../services/utilService";
import {
  reminderParams,
  RespReminderInterface,
  RespReminderModel,
} from "./Models/Reminder.model";
import {
  reminderCardParams,
  RespReminderCardModel,
} from "./Components/ReminderCard/Models/ReminderCard.model";
import {
  RespUpdatedReminderCardInterface,
  RespUpdatedReminderCardModel,
  updatedReminderCardParams,
} from "./Components/ReminderCard/Models/UpdatedReminderCard.model";

const getReminderList = async (
  params: reminderParams
): Promise<RespReminderInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/reminder/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const reminderResp = res as RespReminderModel;
      const reminderResponse = setReminderModel(reminderResp);
      const result: RespReminderInterface = {
        isSuccess: reminderResp.isSuccess,
        displayReminderContainer: reminderResponse,
        status: reminderResp.status,
        message: reminderResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: RespReminderInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getUpdatedReminderCardList = async (
  params: updatedReminderCardParams
): Promise<RespUpdatedReminderCardInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/reminder/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const updatedReminderResp = res as RespUpdatedReminderCardModel;
      const rupdatedReminderResponse =
        setUpdatedReminderCardModel(updatedReminderResp);
      const result: RespUpdatedReminderCardInterface = {
        isSuccess: updatedReminderResp.isSuccess,
        displayUpdatedReminderCard: rupdatedReminderResponse,
        status: updatedReminderResp.status,
        message: updatedReminderResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: RespUpdatedReminderCardInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getReminderCardList = async (
  params: reminderCardParams
): Promise<RespReminderInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/reminder/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const reminderResp = res as RespReminderModel;
      const reminderResponse = setReminderCardModel(reminderResp);
      const result: RespReminderInterface = {
        isSuccess: reminderResp.isSuccess,
        displayReminderContainer: reminderResponse,
        status: reminderResp.status,
        message: reminderResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: RespReminderInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const setReminderModel = (payload: RespReminderModel): any => {
  let ReminderListArray = payload.result?.map((object: any) => {
    return {
      id: object.id,
      title: object.title,
      time: object.time,
      bedName: object.bed_name,
    };
  });

  return ReminderListArray;
};

const setReminderCardModel = (payload: RespReminderCardModel): any => {
  let ReminderCardListArray = payload.result?.map((object: any) => {
    return {
      id: object.id,
      title: object.title,
      time: object.time,
      bedName: object.bed_name,
    };
  });

  return ReminderCardListArray;
};

const setUpdatedReminderCardModel = (
  payload: RespUpdatedReminderCardModel
): any => {
  let UpdatedReminderCardListArray = payload.result?.map((object: any) => {
    return {
      id: object.id,
      title: object.title,
      time: object.time,
      bedName: object.bed_name,
    };
  });

  return UpdatedReminderCardListArray;
};

const handleErrorResponse = () => {};

export const reminderService = {
  getReminderList,
  getReminderCardList,
  getUpdatedReminderCardList,
  handleErrorResponse,
};
